module.exports = __webpack_public_path__ + "media/images/main_article_post-c1dc4c5b1807f73540dd29bd80cbb761.png";